<template>
  <!--
      作者：zhuchangtao
      时间：2020-12-30
      描述：插件中心-素材-添加
    -->
  <div class="product-add pb50">
   <!--添加素材-->
    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">添加素材</div>
      <el-form-item label="素材标题" prop="material_title"><el-input v-model="form.material_title" placeholder="请输入素材标题" class="max-w460"></el-input></el-form-item>
      <el-form-item label="描述" prop="dec">
        <el-input type="textarea" rows="5" v-model="form.dec" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="素材类型：" :rules="[{ required: true, message: '素材类型' }]" prop="material_type">
        <el-radio-group v-model="form.material_type">
          <el-radio :label="10">图片</el-radio>
          <el-radio :label="20">视频</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="素材图片：" :rules="[{ required: true, message: '请上传素材图片' }]" prop="image" v-if="form.material_type == 10">
        <div class="draggable-list">
          <draggable class="wrapper" v-model="form.image">
            <transition-group>
              <div class="item" v-for="item in form.image" :key="item.file_path">
                <img v-img-url="item.file_path" />
                <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(item)"><i class="el-icon-close"></i></a>
              </div>
            </transition-group>
          </draggable>
          <div class="item img-select" @click="openProductUpload"><i class="el-icon-plus"></i></div>
        </div>
      </el-form-item>
      <el-form-item label="素材视频" v-if="form.material_type == 20">
        <div>
          <el-button type="primary" @click="openVideoUpload">上传视频</el-button>
          <video :src="videopath" class="mt10" width="120px;" height="120px" v-if="isVideo" :isVideo="isVideo" controls="controls" style="display: block;" />
          <!--上传图片组件-->
          <Video v-if="isvideoupload" :config="{ total: 1 }" :isvideoupload="isvideoupload" @returnImgs="returnVideoFunc">上传视频</Video>
        </div>
      </el-form-item>
      <el-form-item label="素材分类">
        <el-select v-model="form.category_id" placeholder="请选择">
          <el-option v-for="(item, index) in catgory" :key="index" :label="item.name" :value="item.category_id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="虚拟阅读量"><el-input type="number" v-model="form.virtual_views" placeholder="请输入数字" class="max-w460"></el-input></el-form-item>
      <el-form-item label="素材状态">
        <el-radio-group v-model="form.material_status">
          <el-radio :label="1">显示</el-radio>
          <el-radio :label="0">隐藏</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="排序"><el-input type="number" v-model="form.material_sort" placeholder="请输入数字" class="max-w460"></el-input></el-form-item>
      <el-form-item label="发布人头像">
        <div>
          <el-button type="primary" @click="openUpload">上传图片</el-button>
          <img :src="path" class="mt10" width="120px;" v-if="isImg" :isImg="isImg" />
          <!--上传图片组件-->
          <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
        </div>
      </el-form-item>
      <el-form-item label="发布人昵称" prop="nickName"><el-input v-model="form.nickName" placeholder="请输入发布人昵称" class="max-w460"></el-input></el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <!--商品图片组件-->
    <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload>
  </div>
</template>

<script>
import MaterialApi from '@/api/material.js';

import Upload from '@/components/file/Upload';
import Video from '@/components/file/Video';
import draggable from 'vuedraggable';
export default {
  components: {
    Video: Video,

    /*图片上传*/
    Upload: Upload,
    draggable,
  },
  data() {
    return {
      /*是否上传图片*/
      isupload: false,
      isvideoupload:false,
      isImg: false,
      isVideo: false,
      isProductUpload: false,
      path: '',
      videopath: '',
      /*form表单数据*/
      form: {
        nickName:'',
        material_title: '',
        category_id: '',
        image_id: '',
        video_id:'',
        avatar:"",
        material_sort: 1,
        material_status: 1,
        virtual_views: 1,
        image: [],
        dec: '',
        material_type:10
      },
      /*素材类别*/
      catgory: [],
      loading: false,
      /*验证规则*/
      rules: {
        material_title: [{ required: true, message: '请输入素材标题', trigger: 'blur' }],
        nickName: [{ required: true, message: '请输入发布人昵称', trigger: 'blur' }],
        dec: [{ required: true, message: '请输入素材描述', trigger: 'blur' }]
      }
    };
  },

  created() {
    /*获取列表*/
    this.getCategoryList();
  },
  methods: {
    /*打开上传图片*/
    openProductUpload: function() {
      this.isProductUpload = true;
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if (e != null) {
        let imgs = this.form.image.concat(e);
        this.$set(this.form, 'image', imgs);
      }
      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(e) {
      for (var i = 0; i < this.form.image.length; i++) {
        if (e.file_id == this.form.image[i].file_id) {
          this.form.image.splice(i, 1);
        }
      }
    },
    /*上传*/
    openUpload() {
      this.isupload = true;
    },

    /*获取图片*/
    returnImgsFunc(e) {
      let self = this;
      if (e != null) {
        this.form.avatar = e[0].file_id;
        this.path = e[0].file_path;
        this.isImg = true;
      }
      this.isupload = false;
    },
    /*上传视频*/
    openVideoUpload() {
      this.isvideoupload = true;
    },

    /*获取视频*/
    returnVideoFunc(e) {
      let self = this;
      if (e != null) {
        this.form.video_id = e[0].file_id;
        this.videopath = e[0].file_path;
        this.isVideo = true;
      }
      this.isvideoupload = false;
    },
    /*获取素材类别*/
    getCategoryList() {
      let self = this;
      let Params = {};

      MaterialApi.toAddMaterial(Params, true)
        .then(res => {
          self.catgory = res.data.catgory;
          if(self.catgory.length > 0){
            self.form.category_id = self.catgory[0].category_id;
          }
        })
        .catch(error => {

        });
    },

    /*添加素材*/
    onSubmit() {
      let self = this;
      let form = self.form;

      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          MaterialApi.materialAdd(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.$router.push('/plus/material/index');
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回素材列表*/
    cancelFunc() {
      this.$router.push({
        path: '/plus/material/index'
      });
    }
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}
.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/material/material/add.vue